module.exports = __webpack_public_path__ + "static/media/dhh_200x200.5a5fa5e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/dhh_200x200.png
// module id = 213
// module chunks = 0